export default class Tools {
    lazy() {
        const images = document.querySelectorAll('img[data-src]');
        images.forEach( e => {
            if(!e.classList.contains('lazy')){
                e.src = e.dataset.src;
            }
        });
    }

    offset(el) {
        const rect = el.getBoundingClientRect();

        return {
            top: rect.top + window.pageYOffset,
            left: rect.left + window.pageXOffset,
        };
    }
    
    customInputFile() {
        const formInputs = document.querySelectorAll('input[type="file"]');
        formInputs.forEach( item => {
            item.addEventListener('change', this.editCustomInputFileName);
        });   
    }
    
    editCustomInputFileName(input) {
        if (input.currentTarget.dataset.maxsize < input.currentTarget.files[0].size) {
            alert('Le fichier est trop volumineux');
            input.currentTarget.value = '';
        } else {
            input.currentTarget.nextElementSibling.innerHTML = input.currentTarget.files[0].name;
        }
    }
}